import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import BasicForm from 'components/ui-elements/form'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const Wrapper = styled.div`
  padding: ${calculateResponsiveSize(0)} ${calculateResponsiveSize(350)}
    ${calculateResponsiveSize(0)} ${calculateResponsiveSize(350)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100dvh;

  transform: translateY(-20%);
  transition: 1.5s;
  .opened & {
    transform: translateY(0%);
  }

  ${mediaMax('mobile')} {
    padding: ${calculateMobileResponsiveSize(0)}
      ${calculateMobileResponsiveSize(20)};
    transform: translateY(0%);
    transition: 0s;
  }
`

export const Title = styled.div`
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(42)};
  font-weight: 250;
  line-height: ${calculateResponsiveSize(50.4)};
  text-align: left;
  position: relative;
  color: var(--light);
  width: 100%;
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(30)};
    line-height: ${calculateMobileResponsiveSize(36)};
    text-align: center;
  }
`
export const PressInfo = styled.div`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 700;
  line-height: 160%;
  letter-spacing: 0.02em;
  text-align: center;
  text-transform: uppercase;
  color: #ededed;
  padding-bottom: ${calculateResponsiveSize(40)};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 0;
  right: 0;

  a,
  a:hover,
  a:visited {
    color: #ededed;
    font-family: 'Basis Grotesque';
    font-weight: 400;
    font-size: ${calculateResponsiveSize(12)};
    line-height: 160%;
    letter-spacing: 0px;
    text-transform: none;
  }
  ${mediaMax('mobile')} {
    display: none;
  }
`

export const FormContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: ${calculateResponsiveSize(40)};
  position: relative;
  padding-top: ${calculateResponsiveSize(60)};
  padding-bottom: ${calculateResponsiveSize(60)};

  ${mediaMax('mobile')} {
    padding-top: ${calculateMobileResponsiveSize(60)};
    padding-bottom: ${calculateMobileResponsiveSize(60)};
    row-gap: ${calculateMobileResponsiveSize(40)};
  }
`

export const FieldWrapper = styled.div`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '48%')};

  ${mediaMax('mobile')} {
  }
`

export const Form = styled(BasicForm)`
  width: 100%;
`

export const Button = styled((props) => <Link {...props} />)`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(8)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(10.14)};
  letter-spacing: ${calculateResponsiveSize(2)};
  padding-top: ${calculateResponsiveSize(2)};

  text-transform: uppercase;
  width: ${calculateResponsiveSize(90)};
  height: ${calculateResponsiveSize(18)};
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;

  border: ${calculateResponsiveSize(1)} solid var(--light);

  transition: background-color 0.5s, color 0.5s;

  background-color: transparent;
  color: var(--light);

  &:visited {
    color: currentColor;
  }
  &:hover {
    background-color: var(--mid);
    border: ${calculateResponsiveSize(1)} solid var(--mid);
  }
  border-radius: 1.5625vw;
  &:disabled,
  &[disabled] {
    width: 8.5625vw;
  }

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(8)};
    line-height: ${calculateMobileResponsiveSize(10.14)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    height: ${calculateMobileResponsiveSize(18)};
    padding-top: ${calculateMobileResponsiveSize(2)};
    min-width: ${calculateMobileResponsiveSize(90)};
    border-radius: ${calculateMobileResponsiveSize(20)};
  }
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
export const BackWrapper = styled.div`
  display: none;
  ${mediaMax('mobile')} {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: ${calculateMobileResponsiveSize(72)};
    position: absolute;
    left: 0;
  }
`

export const ThankYouMessageTitle = styled.div`
  color: var(--light);
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(42)};
  font-weight: 250;
  line-height: ${calculateResponsiveSize(50.4)};
  text-align: center;
  white-space: break-spaces;

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(42)};
    line-height: ${calculateMobileResponsiveSize(50.4)};
  }
`

export const ThankYouMessageCopy = styled.div`
  color: var(--light);

  margin-top: ${calculateResponsiveSize(30)};

  ${mediaMax('mobile')} {
    margin-top: ${calculateMobileResponsiveSize(30)};
  }
`
export const Mark = styled.div`
  font-family: 'GT America';
  font-size: ${calculateResponsiveSize(18)};
  font-style: italic;
  font-weight: 300;
  line-height: ${calculateResponsiveSize(27)};
  text-align: left;
  color: var(--blue);
  position: absolute;
  right: 0;
  bottom: ${calculateResponsiveSize(35)};
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(14)};
    line-height: ${calculateMobileResponsiveSize(16.8)};
    bottom: ${calculateMobileResponsiveSize(45)};
  }
`
